// frontend/src/utils/navigation.js
//
// Tiny navigation handle so non-React modules (e.g. the axios/fetch
// interceptor in services/index.js) can use react-router's `navigate`
// instead of doing a full-page `window.location.href` reload.
//
// Wired from App.js: a small <NavigationBinder /> component calls
// setNavigate(navigate) on mount so the rest of the app can import
// { goto } here and route without losing state or remounted toasts.

let _navigate = null;

export function setNavigate(navigate) {
  _navigate = navigate;
}

/**
 * Navigate via react-router if available, otherwise fall back to a hard
 * reload. Accepts the same shape as react-router's navigate().
 *
 * @param {string} to - target path (e.g. '/login')
 * @param {object} [options] - { replace, state }
 */
export function goto(to, options = {}) {
  if (_navigate) {
    _navigate(to, options);
    return;
  }
  // Fallback for the brief window before App mounts (or in tests)
  if (typeof window !== 'undefined') {
    window.location.href = to;
  }
}
